import { Config } from 'configs';

export const getTranslatedData = (translations) => {
  if (!translations) {
    return '';
  }

  /*
  if (translations[i18n.language]) {
    return translations[i18n.language];
  } */

  if (translations[Config.DEFAULTS.LANGUAGE]) {
    return translations[Config.DEFAULTS.LANGUAGE];
  }

  if (Object.keys(translations).length > 0) {
    // eslint-disable-next-line no-restricted-syntax, guard-for-in, no-unreachable-loop
    for (const key in translations) {
      return translations[key];
    }
  }

  return '';
};

